<template>
  <a
    :href="to"
    :class="[
      'font-medium text-link underline-offset-2 transition-[text-underline-offset] duration-150 hover:underline-offset-4',
      variant === 'inline' ? 'underline' : 'hover:underline',
    ]"
  >
    <slot />
  </a>
</template>

<script setup>
// In-app navigation link (brand `text-link`, not blue). In the real app this renders
// <router-link :to>; in the showcase it's an <a>. Use AppExternalLink for off-site URLs.
defineProps({
  /** The route target. */
  to: {
    type: String,
    default: '#',
  },
  /**
   * `inline` for a link inside body text (underlined at rest, WCAG 1.4.1); `standalone` for a UI or
   * nav link (colour only, underline on hover).
   */
  variant: {
    type: String,
    default: 'standalone',
    validator: (value) => ['inline', 'standalone'].includes(value),
  },
});
</script>
